import { ISchema } from '../@types'
import { mergeDeep } from '@/helpers/utils'

// Вариант B видит базовый пейвол своей воронки, но помечается Move-юзером в Braze
// (CRM роутит ретаргетинг/велком-цепочки по is_moves_user). На регистрации атрибут
// НЕ ставится — moves-ность exp-юзера становится известна только на пейволе.
export default (schema: ISchema): ISchema =>
	mergeDeep(
		{ ...schema },
		{
			config: {
				brazeAttributes: { is_moves_user: true },
			},
		},
	)
